import styled from "styled-components";

interface IButtonLinkProps {
  color?: string
}

const ButtonLink = styled.a<IButtonLinkProps>`
  background: none;
  font-size: 16px;
  border: none;
  color: ${props => props.color ?? '#fff'};
  cursor: pointer;
  position: relative;
  font-weight: 600;
  svg {
    position: absolute;
    width: 24px;
    height: 24px;
  }
`
export default ButtonLink